const BrowseActionTypes = {
  FETCH_GENRES_START: 'FETCH_GENRES_START',
  FETCH_GENRES_SUCCESS: 'FETCH_GENRES_SUCCESS',
  FETCH_GENRES_FAILURE: 'FETCH_GENRES_FAILURE',
  FETCH_NEW_RELEASES_START: 'FETCH_NEW_RELEASES_START',
  FETCH_NEW_RELEASES_SUCCESS: 'FETCH_NEW_RELEASES_SUCCESS',
  FETCH_NEW_RELEASES_FAILURE: 'FETCH_NEW_RELEASES_FAILURE',
  FETCH_FEATURED_PLAYLISTS_START: 'FETCH_FEATURED_PLAYLISTS_START',
  FETCH_FEATURED_PLAYLISTS_SUCCESS: 'FETCH_FEATURED_PLAYLISTS_SUCCESS',
  FETCH_FEATURED_PLAYLISTS_FAILURE: 'FETCH_FEATURED_PLAYLISTS_FAILURE',
  FETCH_ALBUM_BY_ID_START: 'FETCH_ALBUM_BY_ID_START',
  FETCH_ALBUM_BY_ID_SUCCESS: 'FETCH_ALBUM_BY_ID_SUCCESS',
  FETCH_ALBUM_BY_ID_FAILURE: 'FETCH_ALBUM_BY_ID_FAILURE',
  RESET_ALBUM: 'RESET_ALBUM',
  FETCH_GENRE_PLAYLISTS_START: 'FETCH_GENRE_PLAYLISTS_START',
  FETCH_GENRE_PLAYLISTS_SUCCESS: 'FETCH_GENRE_PLAYLISTS_SUCCESS',
  FETCH_GENRE_PLAYLISTS_FAILURE: 'FETCH_GENRE_PLAYLISTS_FAILURE'
};

export default BrowseActionTypes;
